import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CompareList from "../../Configs/compare.json";
import { ReactComponent as IconCloseLight } from "../../../asserts/imgs/chart/fubon/close_24px_rounded_light.svg";
import common from "../../../asserts/js/common";

export const UPDW = (props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [enable, setEnable] = useState(true);
  const [period, setPeriod] = useState(5);
  const [color, setColor] = useState("0080FF");
  const [thickness, setThickness] = useState(2);
  const [style, setStyle] = useState("s");
  const [showTracker, setShowTracker] = useState(true);

  const [enable2, setEnable2] = useState(true);
  const [period2, setPeriod2] = useState(25);
  const [color2, setColor2] = useState("991100");
  const [thickness2, setThickness2] = useState(2);
  const [style2, setStyle2] = useState("s");
  const [showTracker2, setShowTracker2] = useState(true);

  const [index, setIndex] = useState(CompareList.UPDW[0].value);
  const [height, setHeight] = useState("1");

  const [cc, setCC] = useState("JPN");
  const [value, setValue] = useState(period + "," + period2);

  const [localChartSetting, setLocalChartSetting] = useState(null)

  useEffect(() => {
    let localSetting = common.getlocalChartStorage();

    if (localSetting)
      setLocalChartSetting(localSetting.UPDW_Option)
  }, []);

  useEffect(() => {
    if (localChartSetting) {
      try {
        const UPDW = localChartSetting.option;

        const o1 = UPDW.options[0]
        const o2 = UPDW.options[1]

        let option1 = "";
        let option2 = "";

        option1 = {
          period: o1.period,
          color: o1.color,
          thickness: o1.thickness,
          style: o1.style,
          showTracker: o1.showTracker,
          enabled: o1.enabled,
        };

        option2 = {
          period: o2.period,
          color: o2.color,
          thickness: o2.thickness,
          style: o2.style,
          showTracker: o2.showTracker,
          enabled: o2.enabled,
        };

        let options = [option1, option2];
        setValue(o1.period + "," + o2.period);
        props.onTAValueChange({
          ta: "UPDW",
          name: `${t("chart5.TA.UPDW")} (UPDW)`,
          option: { idx: UPDW.idx, height: UPDW.height, options },
          value: localChartSetting.value,
        });
      } catch { }
    }
  }, [localChartSetting]);

  useEffect(() => {
    const UPDW = props.localChartSetting.UPDW_Option.option;
    const o1 = UPDW.options[0]
    const o2 = UPDW.options[1]

    setEnable(o1.enabled);
    setPeriod(parseInt(o1.period) || period);
    setColor(o1.color);
    setThickness(parseInt(o1.thickness) || thickness);
    setStyle(o1.style);
    setShowTracker(o1.showTracker);

    setEnable2(o2.enabled);
    setPeriod2(parseInt(o2.period) || period2);
    setColor2(o2.color);
    setThickness2(parseInt(o2.thickness) || thickness2);
    setStyle2(o2.style);
    setShowTracker2(o2.showTracker);

    setIndex(UPDW.idx);
    setHeight(UPDW.height);

  }, [props.localChartSetting]);

  useEffect(() => {
    let option1 = "";
    let option2 = "";

    option1 = {
      period: period,
      color: color,
      thickness: thickness,
      style: style,
      showTracker: showTracker,
      enabled: enable,
    };

    option2 = {
      period: period2,
      color: color2,
      thickness: thickness2,
      style: style2,
      showTracker: showTracker2,
      enabled: enable2,
    };

    let options = [option1, option2];
    setValue(period + "," + period2);
    props.onTAValueChange({
      ta: "UPDW",
      name: `${t("chart5.TA.UPDW")} (UPDW)`,
      option: { idx: index, height: height, options },
      value: value,
    });
  }, [
    period,
    color,
    thickness,
    style,
    showTracker,
    enable,
    period2,
    color2,
    thickness2,
    style2,
    showTracker2,
    enable2,
    index,
    height,
  ]);

  useEffect(() => {
    setTAColor();
  }, [props.selectedColor]);

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  useEffect(() => {
    const UPDW = props.localChartSetting.UPDW_Option.option;
    const o1 = UPDW.options[0]
    const o2 = UPDW.options[1]

    setEnable(o1.enabled);
    setPeriod(parseInt(o1.period) || period);
    setColor(o1.color);
    setThickness(parseInt(o1.thickness) || thickness);
    setStyle(o1.style);
    setShowTracker(o1.showTracker);

    setEnable2(o2.enabled);
    setPeriod2(parseInt(o2.period) || period2);
    setColor2(o2.color);
    setThickness2(parseInt(o2.thickness) || thickness2);
    setStyle2(o2.style);
    setShowTracker2(o2.showTracker);

    setIndex(UPDW.idx);
    setHeight(UPDW.height);
  }, [props.isReset]);

  useEffect(() => {
    setCC(props.cc);
  }, [props.cc]);

  const resetALL = () => {
    setEnable(true);
    setPeriod(5);
    setColor("991100");
    setThickness(2);
    setStyle("s");
    setShowTracker(true);

    setEnable2(true);
    setPeriod2(25);
    setColor2("0080FF");
    setThickness2(2);
    setStyle2("s");
    setShowTracker2(true);

    setIndex(CompareList.UPDW[0].value);
    setHeight("1");
  };

  const onResetClick = () => {
    const answer = window.confirm(t("chart5.alertMsg"));
    if (answer) {
      setIsOpen(true);
      resetALL();
    } else {
      setIsOpen(true);
    }
  };

  const openOptionBox = (e) => {
    try {
      if (
        e.target.className.replace(" focus-within", "") ===
        "menusubitem msiaction techicalindicator" ||
        e.target.className.replace(" focus-within", "") === "span" ||
        e.target.className.replace(" focus-within", "") === "optboxarrow" ||
        e.target.className.replace(" focus-within", "") === "msiicon"
      ) {
        if (e.target.className.replace(" focus-within", "") !== "b2dbtn") {
          if (isOpen) setIsOpen(false);
          else setIsOpen(true);
        }
      }
    } catch (err) { }
  };

  // id: string
  const removeTA = (id) => {
    props.removeTA(id);
  };

  // type: string
  const onEnableChange = (type) => {
    switch (type) {
      case "p1":
        if (enable) setEnable(false);
        else setEnable(true);
        break;
      case "p2":
        if (enable2) setEnable2(false);
        else setEnable2(true);
        break;
    }
  };

  // e: any, type: string
  const onStyleChange = (e, type) => {
    switch (type) {
      case "p1":
        setStyle(e.target.value);
        break;
      case "p2":
        setStyle2(e.target.value);
        break;
    }
  };

  // e: any, type: string
  const onPeriodChange = (e, type) => {
    switch (type) {
      case "p1":
        setPeriod(e.target.value);
        break;
      case "p2":
        setPeriod2(e.target.value);
        break;
    }
  };

  // e: any, type: string
  const onThicknessChange = (e, type) => {
    switch (type) {
      case "p1":
        setThickness(e.target.value);
        break;
      case "p2":
        setThickness2(e.target.value);
        break;
    }
  };

  // type: string
  const onShowTracker = (type) => {
    switch (type) {
      case "p1":
        if (showTracker) setShowTracker(false);
        else setShowTracker(true);
        break;
      case "p2":
        if (showTracker2) setShowTracker2(false);
        else setShowTracker2(true);
        break;
    }
  };

  const onIndexChange = (e) => {
    setIndex(e.target.value);
  };

  const onHeightChange = (e) => {
    setHeight(e.target.value);
  };

  const setTAColor = () => {
    switch (props.source) {
      case "UPDW-C1":
        setColor(props.selectedColor);
        break;
      case "UPDW-C2":
        setColor2(props.selectedColor);
        break;
    }
  };

  // color: string, type: any, title: any
  const onColorClick = (color, type, title) => {
    props.onColorClick(color, type, title);
  };

  const onKeyDown = (evt) => {
    if (evt.key === "-") evt.preventDefault();
  };

  const generateSelectOption = () => {
    return (
      <select id="msi-ta-UPDW-idx" onChange={(e) => onIndexChange(e)} value={index}>
        {CompareList.UPDW &&
          CompareList.UPDW.map((item, idx) => (
            <option
              key={idx}
              value={item.value}
              style={
                props.isDarkMode
                  ? { color: "#FFFFFF", background: "#000000" }
                  : {}
              }
            >
              {item.name}
            </option>
          ))}
      </select>
    );
  };

  return (
    <div
      className="menusubitem msiaction techicalindicator"
      id="msi-ta"
      onClick={(e) => openOptionBox(e)}
    >
      {/* <div className="msiicon" onClick={() => removeTA("UPDW")}></div> */}
      <div className="box-container">
        <span className="span">
          {t("chart5.TA.UPDW")} (UPDW) {value}
        </span>
        <IconCloseLight
          className="close-icon"
          onClick={() => removeTA("UPDW")}
        />
      </div>
      <div
        className="optboxarrow"
        style={isOpen ? { transform: "rotate(180deg)" } : {}}
        onClick={(e) => openOptionBox(e)}
      ></div>
      <div
        className="b2dbtn"
        style={isOpen ? { display: "flex" } : {}}
        title="スタイル設定を初期設定に戻す"
        onClick={onResetClick}
      ></div>
      <div className="msi-optbox" style={isOpen ? {} : { display: "none" }}>
        <div
          className="menusubitem checkbox selected"
          style={enable ? {} : { opacity: "0.5" }}
          id="msi-ta-UPDW"
        >
          <div className="flexbox">
            <div
              id="msi-ta-KC-mid-enabled"
              className={enable ? "checkboxbutton-selected" : "checkboxbutton"}
              onClick={(e) => onEnableChange("p1")}
            ></div>
            <div className="taparamlbl">{t("chart5.period")}</div>
            <div className="inputbox taparam">
              <input
                id="msi-ta-KC-mid-period0"
                type="number"
                step="1"
                min="1"
                value={period}
                maxLength={4}
                style={{ width: "40px" }}
                onChange={(e) => onPeriodChange(e, "p1")}
                onKeyDown={onKeyDown}
              />
            </div>
          </div>

          <div className="menusubitem stylebox ">
            <div className="styleboxlbl">{t("chart5.setting")}</div>
            <button
              id="msi-ta-KC-mid-color0"
              className="colorpicker"
              value={color}
              style={{ backgroundColor: "#" + color }}
              onClick={() =>
                onColorClick(color, "UPDW-C1", t("chart5.setting"))
              }
            ></button>
            <div className="inputbox">
              <input
                id="msi-ta-KC-mid-thickness"
                type="number"
                step="1"
                min="1"
                max="9"
                value={thickness}
                maxLength={1}
                style={{ width: "30px" }}
                onChange={(e) => onThicknessChange(e, "p1")}
              />
            </div>
            <div className="selectbox" onChange={(e) => onStyleChange(e, "p1")}>
              <select id="msi-ta-KC-mid-style" value={style}>
                <option value="s">{t("chart5.realLine")}</option>
                <option value="d">{t("chart5.dotLine")}</option>
              </select>
            </div>
            <div className="showtracker">
              <div
                id="msi-ta-KC-mid-showtracker"
                className={
                  showTracker ? "checkboxbutton-selected" : "checkboxbutton"
                }
                onClick={(e) => onShowTracker("p1")}
              ></div>
              <div className="styleboxlbl">{t("chart5.showValue")}</div>
            </div>
          </div>
        </div>

        <div
          className="menusubitem checkbox selected"
          style={enable2 ? {} : { opacity: "0.5" }}
          id="msi-ta-UPDW"
        >
          <div className="flexbox">
            <div
              id="msi-ta-KC-mid-enabled"
              className={enable2 ? "checkboxbutton-selected" : "checkboxbutton"}
              onClick={(e) => onEnableChange("p2")}
            ></div>
            <div className="taparamlbl">{t("chart5.period")}</div>
            <div className="inputbox taparam">
              <input
                id="msi-ta-KC-mid-period0"
                type="number"
                step="1"
                min="1"
                value={period2}
                maxLength={4}
                style={{ width: "40px" }}
                onChange={(e) => onPeriodChange(e, "p2")}
              />
            </div>
          </div>

          <div className="menusubitem stylebox ">
            <div className="styleboxlbl">{t("chart5.setting")}</div>
            <button
              id="msi-ta-KC-mid-color0"
              className="colorpicker"
              value={color2}
              style={{ backgroundColor: "#" + color2 }}
              onClick={() =>
                onColorClick(color, "UPDW-C2", t("chart5.setting"))
              }
            ></button>
            <div className="inputbox">
              <input
                id="msi-ta-KC-mid-thickness"
                type="number"
                step="1"
                min="1"
                max="9"
                value={thickness2}
                maxLength={1}
                style={{ width: "30px" }}
                onChange={(e) => onThicknessChange(e, "p2")}
              />
            </div>
            <div className="selectbox" onChange={(e) => onStyleChange(e, "p2")}>
              <select id="msi-ta-KC-mid-style" value={style2}>
                <option value="s">{t("chart5.realLine")}</option>
                <option value="d">{t("chart5.dotLine")}</option>
              </select>
            </div>
            <div className="showtracker">
              <div
                id="msi-ta-KC-mid-showtracker"
                className={
                  showTracker2 ? "checkboxbutton-selected" : "checkboxbutton"
                }
                onClick={(e) => onShowTracker("p2")}
              ></div>
              <div className="styleboxlbl">{t("chart5.showValue")}</div>
            </div>
          </div>
        </div>
        <div className="menusubitem" id="msi-ta-UPDW">
          <div className="flexbox">
            <div className="taparamlbl">{t("chart5.index")}</div>
            <div className="selectbox taparam">{generateSelectOption()}</div>
          </div>
        </div>

        <div className="menusubitem" id="msi-ta-UI">
          <div className="flexbox">
            <div className="taparamlbl">{t("chart5.displayScreenSize")}</div>
            <div className="selectbox taparam">
              <select
                id="msi-ta-UI-ps-h"
                defaultValue={height}
                onChange={(e) => onHeightChange(e)}
                value={height}
              >
                <option value="2">{t("chart5.large")}</option>
                <option value="1">{t("chart5.normal")}</option>
                <option value="0">{t("chart5.small")}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
